export default {
  title: "Баланс",
  balanceInfo: {
    title: "Информация о балансе",
    subtitle:
      "Отображаемые RC на балансе являются ожидаемой суммой на счету после осуществления взаиморасчетов по всем операциям.",
    moreDetailSpoiler: {
      ru: [
        {
          title: "Фактический баланс",
          description: [
            {
              type: "text",
              value:
                "Включает в себя пополнение баланса через банк, возвраты по отмененным операциям, зачисленные баллы от клиентов. За вычетом выплаты баллов согласно сценариям распределения вознаграждения, списаний за покупки тарифа и услуг, а также суммы «Зарезервировано к выплате» (если установлена).",
            },
          ],
        },
        {
          title: "Ожидают зачисления",
          description: [
            {
              type: "text",
              value:
                "Баллы от клиентов, которые пока не зачислены по причине недостатка средств на вашем фактическом балансе. Сюда же входит клиентское путешествие (вознаграждение от оцифрованных вами клиентов, посетивших другие заведения), которое находится в ожидании зачисления. Ожидание образуется, если на счете партнера, чье заведение посетил оцифрованный вами клиент, недостаточно средств.",
            },
          ],
        },
        {
          title: "Ожидают списания",
          description: [
            {
              type: "text",
              value:
                "Баллы, которые пока не были списаны (согласно сценариям распределения вознаграждения) по причине нехватки средств, а также если у заведения установлена задержка начисления.",
            },
          ],
        },
        {
          title: "Доступно к выводу",
          description: [
            {
              type: "text",
              value:
                "Фактический баланс за вычетом средств, ожидающих списания, суммы установленного депозита, а также суммы «Зарезервировано к выплате» (если установлена).",
            },
          ],
        },
        {
          title: "Зарезервировано к выплате",
          description: [
            {
              type: "text",
              value:
                "Сумма, которая фактически будет выплачена в период взаиморасчетов.",
            },
            {
              type: "text",
              value:
                "Устанавливается 2 раза в месяц в настройках баланса в размере не менее 300 RC и не более текущего баланса «Доступно к выводу». Чтобы установить сумму к выплате, нажмите «Настройки» в карточке баланса юрлица, для которого хотите настроить вывод средств.",
            },
            {
              type: "text",
              value:
                "Если сумма не установлена до проведения взаиморасчетов и не включен вывод средств по сумме баланса «Доступно к выводу», вывод средств не производится.",
            },
            {
              type: "text",
              value:
                "Ориентировочные даты списания средств для выплаты с баланса — с 1 по 5 и с 16 по 20 число каждого месяца. Выплата на расчетные счета осуществляется в течение 14 дней после даты списания с баланса в кабинете.",
            },
          ],
        },
        {
          title: "Настройка вывода средств",
          description: [
            {
              type: "v-text",
              value:
                "Чтобы вывести средства, нужно выбрать способ выплаты в настройках. Выплата будет осуществлена согласно договору п. 4.6. Если не выбрать ни&nbsp;один из&nbsp;вариантов в кабинете RC&nbsp;CITY, в&nbsp;указанный период выплата средств для&nbsp;данного юрлица производиться не&nbsp;будет.",
            },
            {
              type: "list",
              title:
                "Чтобы установить сумму, которую вы хотите вывести, необходимо:",
              list: [
                "Перейти в раздел «Баланс», нажав на кнопку «Баланс» в правом верхнем углу.",
                "Нажать «Настройки» в карточке баланса.",
                "Выбрать предпочтительный способ выплаты средств:",
                "По сумме «Зарезервировано к выводу»Средства будут зарезервированы до момента выплаты, их нельзя будет использовать на покупки тарифов и услуг, т.к фактический баланс будет уменьшен на установленное значение. Способ недоступен, когда значение суммы «Доступно к выводу» меньше 300 RC. Сумму вы устанавливаете самостоятельно.",
                "По сумме «Доступно к выводу»Выплата средств будет сумме, равной значению баланса “Доступно к выводу” на момент проведения взаиморасчетов при условии, что она будет не менее 300 RC.",
                "Нажмите на «Применить и закрыть».",
              ],
            },
          ],
        },
      ],
      ruNKO: [
        {
          title: "Акт сверки",
          description: [
            {
              type: "v-text",
              value:
                "Получить акты сверки и&nbsp;выполненных работ можно через&nbsp;службу поддержки. Для&nbsp;этого отправьте запрос через&nbsp;форму обратной связи в&nbsp;правом нижнем углу кабинета RC CITY или&nbsp;отправьте письмо на&nbsp;электронную почту <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "В запросе необходимо указать:",
              list: [
                "ИНН",
                "Наименование юридического лица",
                "Период, за который требуется акт сверки или суммы, по которому необходим акт выполненных работ",
              ],
            },
          ],
        },
      ],
      ruKO: [
        {
          title: "Лимит на прием баллов от клиентов",
          description: [
            {
              type: "v-text",
              value:
                "Ограничение на прием баллов в месяц действует для всех коммерческих юрлиц России.",
            },
            {
              type: "v-text",
              value:
                "Обновляется&nbsp;1 числа каждого месяца в&nbsp;00:00 по&nbsp;МСК (UTC+3). При полном исчерпании лимита прием баллов от&nbsp;клиентов будет временно недоступен до&nbsp;начала следующего месяца.",
            },
            {
              type: "v-text",
              value:
                "Доступный остаток на&nbsp;прием баллов в&nbsp;текущем месяце отображается в&nbsp;карточке баланса юрлица в подразделе <a class='spoiler-link'> «Баланс». </a>",
            },
            {
              type: "v-text",
              value:
                "Баллы за клиентское путешествие и&nbsp;применение подарочных карт не&nbsp;учитываются и не уменьшают сумму лимита.",
            },
          ],
        },
        {
          title: "Акт сверки",
          description: [
            {
              type: "v-text",
              value:
                "Получить акты сверки и&nbsp;выполненных работ можно через&nbsp;службу поддержки. Для&nbsp;этого отправьте запрос через&nbsp;форму обратной связи в&nbsp;правом нижнем углу кабинета RC CITY или&nbsp;отправьте письмо на&nbsp;электронную почту <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "В запросе необходимо указать:",
              list: [
                "ИНН",
                "Наименование юридического лица",
                "Период, за который требуется акт сверки или суммы, по которому необходим акт выполненных работ",
              ],
            },
          ],
        },
      ],
      noRu: [
        {
          title: "Фактический баланс",
          description: [
            {
              type: "text",
              value:
                "Включает в себя пополнение баланса через банк, возвраты по отмененным операциям, зачисленные баллы от клиентов. За вычетом выплаты баллов согласно сценариям распределения вознаграждения и списаний за покупки тарифа и услуг.",
            },
          ],
        },
        {
          title: "Ожидают зачисления",
          description: [
            {
              type: "text",
              value:
                "Баллы от клиентов, которые пока не зачислены по причине недостатка средств на вашем фактическом балансе для проведения взаиморасчета. Сюда же входит клиентское путешествие (вознаграждение от оцифрованных вами клиентов, посетивших другие заведения), которое находится в ожидании зачисления. Ожидание образуется, если на счете партнера, чье заведение посетил оцифрованный вами клиент, недостаточно средств.",
            },
          ],
        },
        {
          title: "Ожидают списания",
          description: [
            {
              type: "text",
              value:
                "Баллы, которые пока не были списаны (согласно сценариям распределения вознаграждения) по причине нехватки средств, а также если у заведения установлена задержка начисления.",
            },
          ],
        },
        {
          title: "Доступно к выводу",
          description: [
            {
              type: "text",
              value:
                "Фактический баланс за вычетом средств, ожидающих списания, и суммы установленного депозита.",
            },
          ],
        },
        {
          title: "Акт сверки",
          description: [
            {
              type: "v-text",
              value:
                "Получить акты сверки и&nbsp;выполненных работ можно через&nbsp;службу поддержки. Для&nbsp;этого отправьте запрос через&nbsp;форму обратной связи в&nbsp;правом нижнем углу кабинета RC CITY или&nbsp;отправьте письмо на&nbsp;электронную почту <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "В запросе необходимо указать:",
              list: [
                "ИНН",
                "Наименование юридического лица",
                "Период, за который требуется акт сверки или суммы, по которому необходим акт выполненных работ",
              ],
            },
          ],
        },
      ],
    },
  },
  aboutChapter: {
    title: "Информация о подразделе",
    description: [
      "Баланс отражает информацию о ваших средствах, которые будут выплачены вам в\u00A0период взаиморасчетов.",
      "Также на странице баланс представлена полная его детализация, которая помогает лучше контролировать свои финансы и понимать текущее состояние своих средств.",
    ],
  },
  withdrawalInstructionName: "Инструкция по выводу средств из кабинета RC CITY",
  reservedForPayment: "Зарезервировано к выплате",
  withdrawalOfFund: "Вывод средств",
  power: {
    on: "Включен",
    off: "Отключен",
  },
  actualBalance: "Фактический баланс",
  expectedCredited: "Ожидают зачисления",
  expectedDebiting: "Ожидают списания",
  availableWithdrawal: "Доступно к выводу",
  statusText: {
    needAdjustPaymentMethod:
      "Для вывода средств необходимо настроить способ выплаты",
    bySumReservedOnBalance:
      "По сумме, зарезервированной на балансе до момента выплаты",
    bySumAvailableToWithdrawal:
      "По сумме «Доступно к выводу» на момент проведения взаиморасчетов",
  },

  topupModal: {
    title: "Укажите сумму пополнения",
    entityPayer: "Юрлицо - плательщик",
    topupSum: "Сумма пополнения",
  },
  createAndDownloadAccount: "Сформировать и скачать счет",
  byReservedSum: "По сумме «Зарезервировано к выплате»",
  byAvailableSum: "По сумме «Доступно к выводу»",
  bySettedSum: "По установленной сумме",
  bySettedSumDesc:
    "Средства будут зарезервированы до момента выплаты, их нельзя будет использовать для покупки тарифа и услуг, т.к. фактический баланс будет уменьшен на установленное значение. Способ недоступен, когда значение суммы «Доступно к выводу» менее 300 RC.",
  byAvailableSumDesc:
    "Выплата средств будет произведена в сумме, равной значению баланса «Доступно к выводу» на момент проведения взаиморасчетов при условии, что она будет не менее 300 RC.",
  success: "Успешно",
  settings: {
    title: "Настройки вывода средств",
    banner: {
      inProgress: {
        title: "Производятся выплаты",
        description: [
          "В период выплат изменение настроек вывода средств недоступно.",
          "Установить настройки для следующей выплаты можно будет после завершения текущего процесса выплаты средств.",
        ],
      },
      inPending: {
        title: "Ожидается выплата средств",
        description: [
          "Она будет осуществлена согласно договору п. 4.6. Ориентировочные даты списания средств для выплаты с баланса — с 1 по 5 и с 16 по 20 число каждого месяца. Выплата на расчетные счета осуществляется в течение 14 дней после даты списания с баланса в кабинете.",
          "Чтобы отменить получение выплаты, изменить способ выплаты или установить другую сумму, нажмите кнопку «Отключить вывод средств».",
        ],
      },
      inDisabled: {
        title: "Вывод средств отключен",
        description: [
          "Чтобы вывести средства, выберите способ выплаты и примените настройки. Выплата будет осуществлена согласно договору п. 4.6.",
          "Ориентировочные даты списания средств для выплаты с баланса — с 1 по 5 и с 16 по 20 число каждого месяца. Выплата на расчетные счета осуществляется в течение 14 дней после даты списания с баланса в кабинете.",
          "Если ничего не выбрать, в указанный период выплата средств для данного юрлица производиться не будет.",
        ],
      },
    },
    paymentMethod: "Способ выплаты",
    sumToBePaid: "Сумма к выплате",
    validSumTobePaidValid:
      "Можно установить сумму не менее 300 RC и не более текущего значения баланса «Доступно к выводу»",
    entity: "Юрлицо",
    notSelectedNoPayment: "Не выбран, выплата не производится",
    bank: {
      BIC: "БИК банка",
      naming: "Наименование банка",
      paymentAccount: "Номер расчетного счета",
      corpAccount: "Корсчет",
      depositAmount: "Сумма депозита",
      depositAmountHint:
        "Минимальный остаток на счете. Сумма, которая остается на балансе при выводе средств.",
      changeDetails: "Изменить реквизиты",
    },
    disableWithdrawal: "Отключить вывод средств",
    disabledWithdrawalForDefinEntity:
      "Вывод средств для юрлица {entityName} отключен",
  },
  editPaymentModal: {
    title: "Хотите изменить банковские реквизиты или сумму депозита?",
    subtitle:
      "Для редактирования вы будете переведены в подраздел «Юрлица». После внесения изменений вернитесь обратно на страницу «Баланс», чтобы настроить вывод средств по новым реквизитам.",
    toEdit: "К редактированию",
  },
  resetPaymentModal: {
    title: "Отменить настройки вывода средств?",
    subTitle:
      "При нажатии кнопки «Да, отменить» настройки вывода средств будут сброшены. Выплата денежных средств для данного юрлица производиться не будет.",
    yesCancel: "Да, отменить",
  },
  disabledPaymentModal: {
    title: "Подтвердите отключение вывода средств",
    subtitle: {
      withFullWithdrawal: [
        "Нажимая кнопку «Подтвердить», ранее установленная сумма к выплате снимется с резерва. После этого вы сможете изменить способ выплаты или установить новую сумму к выплате.",
        "Если новый способ вывода средств не будет выбран, для данного юрлица выплата производиться не будет.",
        "Важно! Установка новой суммы к выплате будет возможна только в пределах баланса «Доступно к выводу», значение которого после отмены резерва может отличаться от текущего.",
      ],
      withoutFullWithdrawal: [
        "После отключения можно будет включить его заново или выбрать другой способ выплаты.",
        "Если новый способ вывода средств не будет выбран, для данного юрлица выплата производиться не будет.",
      ],
    },
  },
  errorCard: {
    title: "Оплатите задолженность",
    description:
      "Скачайте и оплатите счет, отправленный на вашу электронную почту, или создайте его самостоятельно, нажав кнопку «Пополнить».",
  },
};
